export enum ContentType {
  Json,
  Text,
  Blob,
  void,
}
